import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const BulletListContainer = styled.div`
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 64px;

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: row;
    column-gap: 26px;
    margin-left: 24px;
    margin-right: 24px;
    margin-bottom: 120px;
  }

  @media (min-width: ${breakpoints.desktop}) {
    flex-direction: row;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 120px;
  }
`;

export const CustomDesc = styled.p`
  font-family: ${fonts.light};
  font-weight: 400;
  color: ${colors.$262626};
  min-height: 40px;
  ${pxToCssFont(24, 32)}
  margin-top: 0;
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 24px;

  p {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

export const CustomTitle = styled.p`
  font-family: ${fonts.regular};
  font-weight: 400;
  color: ${colors.$262626};
  min-height: 40px;
  ${pxToCssFont(24, 32)}
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 24px;

  p {
    margin-top: 0;
    margin-bottom: 0;
  }
`;

